import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_search } from '@/hooks/store/use_slices';
import { on_user_leave_from_entity, try_update_viewed_entity } from '@/utils/utils_client_workspace_child_entity_viewers';
import { DTOSearchSettings } from '@shared/dto/search/dto_search_settings';
import { useRef } from 'react';

export function WatcherViewEntitySearch() {
  const { search_current } = use_slice_search(['search_current']);

  const ref_entity = useRef(DTOSearchSettings.CREATE_STUB());

  /*
   * EFFECTS
   */
  use_effect(() => {
    if (ref_entity.current._id == search_current._id) return;

    ref_entity.current = search_current;

    void try_update_viewed_entity(search_current);

    return () => {
      if (ref_entity.current.is_stub()) return;

      void on_user_leave_from_entity(ref_entity.current._id, ref_entity.current.type);
    };
  }, [search_current]);

  return <></>;
}
